var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.412,
    height: 20.412,
    viewBox: "0 0 20.412 20.412",
    fill: "#2d70d0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_67",
    "data-name": "Trac\\xE9 67",
    d: "M20.068,18.947l-2.612-2.612,2.612-2.612a.792.792,0,0,0-1.12-1.12l-2.612,2.612L13.724,12.6a.792.792,0,1,0-1.12,1.12l2.612,2.612L12.6,18.947a.766.766,0,0,0,0,1.12.787.787,0,0,0,1.12,0l2.612-2.612,2.612,2.612a.8.8,0,0,0,1.12,0A.787.787,0,0,0,20.068,18.947Z",
    transform: "translate(-2.755 -2.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_68",
    "data-name": "Trac\\xE9 68",
    d: "M13.581,4.749A8.828,8.828,0,1,1,7.335,7.335a8.774,8.774,0,0,1,6.246-2.586m0-1.374A10.206,10.206,0,1,0,23.787,13.581,10.2,10.2,0,0,0,13.581,3.375Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.7ff4c588.svg";
export { ForwardRef as ReactComponent };